;(function ($) {
  'use strict';

	$(document).ready(function() {
		initialize_menuMain();
    iamA_select();
	});

	function initialize_menuMain() {
    const $body = $('body');
    const $html = $('html');
    const $header = $('.l-header');
    let $submenuToggles = $('.menu__submenu-toggle', $header);

    // adds classes to items bases on its label
    $('.main-menu > .menu-item > a').each(function() {
      let $copy = $(this).text();
      let $class = $copy.toLowerCase().replace(/[\u0300-\u036f]/g, '') // Remove accents
                    .replace(/([^\w]+|\s+)/g, '-') // Replace space and other characters by hyphen
                    .replace(/\-\-+/g, '-') // Replaces multiple hyphens by one hyphen
                    .replace(/(^-+|-+$)/g, ''); // Remove extra hyphens from beginning or end of the string
      $(this).parent().addClass($class);
    });
    // if first item is "I am a...", avoid tabbing the link
    if ( $('.main-menu > .menu-item.i-am-a:first-child').length ) {
      $('.main-menu > .menu-item.i-am-a > a').attr('tabindex', -1);
    }

    // Submenu toggle
    $submenuToggles.click(function(evt) {
      evt.preventDefault();
      evt.stopPropagation();

      var $containerItem = $(this).parent();
      var $this = $(this);

      // desktop
      if ( $('.menu-main-toggle').css('display') == 'none' ) {

      	// if submenu is closed
        if ( !$(this).parents('.submenu--revealed').length ) {

        	// close all other submenus
        	$(this).parents('.main-menu').find('.submenu--revealed')
        		.attr('aria-expanded', false)
          	.removeClass('submenu--revealed')
            .find('.menu__submenu').hide();

          $(this).parent().attr('aria-expanded',true);
          $(this).attr('title', $(this).attr('title').replace('Open','Close'));
        }
        // if submenu is open
        else {
        	$(this).attr('title', $(this).attr('title').replace('Close','Open'));
        	$(this).parent().attr('aria-expanded',false);
        }

        $(this).next('.menu__submenu').toggle()
          .parent().toggleClass('submenu--revealed');
      }


      // mobile
      else {
        // if submenu is closed
        if ( !$(this).parents('.submenu--revealed').length ) {

          // close all other submenus
          $(this).parents('.main-menu').find('.submenu--revealed')
            .attr('aria-expanded', false)
            .removeClass('submenu--revealed')
            .find('.menu__submenu').slideUp();

          $(this).parent().attr('aria-expanded',true);
          $(this).attr('title', $(this).attr('title').replace('Open','Close'));
        }
        // if submenu is open
        else {
          $(this).attr('title', $(this).attr('title').replace('Close','Open'));
          $(this).parent().attr('aria-expanded',false);
        }

        $(this).next('.menu__submenu').slideToggle()
          .parent().toggleClass('submenu--revealed');
      }
    });
  }

  // Close "I am a..." link when click happens outside of it, to mimic an actual select's behavior
  function iamA_select() {
    let $popup = '.i-am-a.submenu--revealed > .menu__submenu';
    $(document).click(function(event) { 
      var $target = $(event.target);
      if ( !$target.closest($popup).length && $($popup).is(':visible') ) {
        $($popup).prev('.menu__submenu-toggle').trigger('click');
      }        
    });
  }

})(jQuery);